<template>
  <div class="header">
    <div class="patient-banner">
      <div class="patient-main-info">
        <h1 style="color: #fff"><i class="fas fa-child"></i> Child Welfare Clinic</h1>
        <div class="patient-id-section">
          <span class="patient-id">Patient: {{ patient.name }}</span>
          <span class="patient-id">OPD: {{ patient.opd }}</span>
          <span class="last-visit">Age: {{ getAge(patient.dob) }}</span>
          <span class="last-visit">Gender: {{ patient.gender == 1 ? "Male" : "Female" }}</span>
        </div>
      </div>
    </div>
    <cwc_head :visit_id="visit_id" />
  </div>
</template>

<script>
import cwc_head from "./cwc_head.vue";
import { generalApiRequest } from "../../../../api/apiIndex";
import getAge from "../../../../timezone/dob_to_age";

export default {
  name: "full_cwc_head",
  data() {
    return { patient: {} };
  },
  components: { cwc_head },
  props: {
    visit_id: { type: [String, Number], required: false },
  },
  methods: {
    getAge,
    async findPatient() {
      const uri = `get_patient_object_from_visit/${this.$route.params.visit_id}`;
      const response = await generalApiRequest(uri, "GET", {}, 1);
      this.patient = response.data;
    },
  },
  mounted() {
    this.findPatient();
  },
};
</script>

<style scoped>
.header { background: white; border-radius: 10px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); margin-bottom: 25px; overflow: hidden; }
.patient-banner { display: flex; justify-content: space-between; align-items: center; padding: 20px 30px; background: linear-gradient(135deg, #276749 0%, #48bb78 100%); color: white; }
.patient-main-info h1 { font-size: 28px; font-weight: 600; margin-bottom: 10px; }
.patient-main-info h1 i { margin-right: 10px; }
.patient-id-section { display: flex; gap: 30px; font-size: 16px; }
.patient-id-section span { background: rgba(255, 255, 255, 0.2); padding: 5px 15px; border-radius: 20px; }
</style>
